import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../../../button/src";
import { ButtonInLink } from "../../../button-in-link/src";
export const ButtonOrButtonInLink = ({ isFullWidth, item, }) => {
    if (item === null || item === void 0 ? void 0 : item.linkProps) {
        return _jsx(ButtonInLink, Object.assign({}, item, { isFullWidth: isFullWidth }));
    }
    return _jsx(Button, Object.assign({}, item, { isFullWidth: isFullWidth }));
};
//# sourceMappingURL=ButtonOrButtonInLink.js.map